/* eslint-disable */
// /src/pages/EduHomePage.jsx
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import BrandHeader from "../components/BrandHeader";
import { listEduPublic } from "../services/eduPublicService";
import { useAppConfig } from "../context/AppConfigContext";
import PageTopBar from "../components/PageTopBar";

const Wrap = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, #D7E8FF 0%, #EAF3FF 100%);
  display: flex;
  flex-direction: column;
`;
const Sheet = styled.div`
  background: #F7FAFF;
  box-shadow: 0 -4px 20px rgba(0,0,0,.05);
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
`;
const Body = styled.div`
  flex:1;
  display:grid;
  grid-template-rows:auto auto 1fr auto;
  row-gap:14px;
  padding:16px;
`;

/* 상단 안내 카드 */
const IntroCard = styled.div`
  background:#fff;
  border-radius:16px;
  box-shadow:0 1px 10px rgba(0,0,0,.06);
  padding:18px;
  display:grid;
  grid-template-columns:1fr auto;
  gap:12px;
  align-items:center;
`;
const IntroText = styled.div`
  h2{
    margin:0 0 8px;
    font-size:18px;
    font-weight:900;
    color:#0f172a;
  }
  p{
    margin:0;
    color:#475569;
    line-height:1.5;
    font-size:14px;
    white-space:pre-line; /* 줄바꿈 그대로 표시 */
  }
`;
const Mascot = styled.div`
  width:64px;
  height:64px;
  border-radius:16px;
  background:#fff7ed;
  display:grid;
  place-items:center;
  font-size:28px;
  box-shadow:inset 0 0 0 2px #ffe4c7;

  img{
    width:100%;
    height:100%;
    object-fit:cover;
    border-radius:16px;
    display:block;
  }
`;

/* 자료 섹션 */
const Section = styled.section`
  background:#fff;
  border-radius:16px;
  box-shadow:0 1px 10px rgba(0,0,0,.06);
  padding:16px;
`;
const SectionTitle = styled.h3`
  margin:0 0 10px;
  font-size:16px;
  font-weight:900;
  color:#0f172a;
`;

const List = styled.ul`
  list-style:none;
  margin:0;
  padding:0;
  display:grid;
  gap:10px;
`;
const Item = styled.li`
  background:#f1f5ff;
  border-radius:12px;
  padding:12px 14px;
  display:grid;
  grid-template-columns:1fr auto;
  gap:10px;
  align-items:center;
  cursor:pointer;
  color:#1f2937;
  font-weight:700;
  transition:transform .06s ease, box-shadow .12s ease;
  &:active{transform:translateY(1px)}
  .sub{font-weight:500;color:#64748b;margin-left:6px}
`;
const ItemText = styled.div`
  display:grid;
  gap:6px;
  .title{
    font-weight:900;
    color:#0f172a;
  }
  .snippet{
    font-weight:600;
    color:#64748b;
    font-size:13px;
    line-height:1.4;
    display:-webkit-box;
    -webkit-line-clamp:2;
    -webkit-box-orient:vertical;
    overflow:hidden;
  }
  .meta{
    font-size:12px;
    color:#64748b;
  }
`;
const MetaVideo = styled.span`
  margin-left:4px;
  font-weight:800;
  color:#1d4ed8;
`;

/* CTA 버튼: 색상 동적으로 받도록 수정 */
const CTA = styled.button`
  margin-top:6px;
  height:48px;
  width:100%;
  border:0;
  border-radius:12px;
  background:${p => p.$bg || "var(--color-brand,#D9A679)"};
  color:${p => p.$color || "#fff"};
  font-weight:900;
  font-size:15px;
  box-shadow:0 6px 16px rgba(0,0,0,.08);
  cursor:pointer;
  &:active{transform:translateY(1px)}
`;

const BottomPad = styled.div`
  height:max(24px, env(safe-area-inset-bottom));
`;

/* 인라인 스피너 (공지에서 썼던 스타일 그대로) */
const InlineSpinner = styled.div`
  width:16px;
  height:16px;
  border-radius:50%;
  border:2px solid rgba(148,163,184,0.5);
  border-top-color:#4f46e5;
  animation:spin 0.8s linear infinite;
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;

function fmt(d) {
  try {
    return (d instanceof Date ? d : new Date(d)).toISOString().slice(0, 10);
  } catch {
    return "-";
  }
}
function isNew(d) {
  try {
    const t = (d instanceof Date ? d : new Date(d)).getTime();
    return (Date.now() - t) < 1000 * 60 * 60 * 24 * 10;
  } catch {
    return false;
  }
}

export default function EduHomePage() {
  const nav = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showSpinner, setShowSpinner] = useState(true); // 스피너 최소 노출용

  // ✅ 기본 5개만 노출, "자료 더 보기" 누르면 5개씩 증가
  const [visibleCount, setVisibleCount] = useState(5);

  const { config } = useAppConfig();
  const detail = config.detailScreens || {};
  const eduCfg = detail.educationCenter || {};

  // 관리자에서 설정한 값들
  const channelTitle =
    eduCfg.channelTitle || "Hey’ Way 교육채널";
  const channelDescription =
    eduCfg.channelDescription ||
    "매출 성장과 고객 만족을 위한 스마트 가이드.\n쉽고 빠르게 배우고 바로 실천하세요.";
  const channelIconImg = eduCfg.channelIconImg || "";

  const sectionTitleText = eduCfg.sectionTitle || "교육 자료";
  const seeMoreLabel = eduCfg.seeMoreLabel || "자료 더 보기";
  const seeMoreBgColor = eduCfg.seeMoreBgColor || "var(--color-brand,#D9A679)";
  const seeMoreTextColor = eduCfg.seeMoreTextColor || "#ffffff";

  const openDetail = (id) => nav(`/edu/${id}`);

  useEffect(() => {
    let alive = true;

    (async () => {
      const start = Date.now();
      try {
        setLoading(true);
        setShowSpinner(true);

        const list = await listEduPublic({ limit: 100 });
        if (!alive) return;
        setRows(list);
      } finally {
        if (!alive) return;

        setLoading(false);

        const elapsed = Date.now() - start;
        const remain = Math.max(0, 2000 - elapsed); // 최소 2초

        if (remain === 0) {
          setShowSpinner(false);
        } else {
          setTimeout(() => {
            if (alive) setShowSpinner(false);
          }, remain);
        }
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  // rows 바뀔 때마다 기본 5개부터 다시
  useEffect(() => {
    setVisibleCount(5);
  }, [rows.length]);

  const displayLoading = loading || showSpinner;
  const has = rows.length > 0;

  const visibleRows = rows.slice(0, visibleCount);
  const hasMore = visibleCount < rows.length;

  const handleLoadMore = () => {
    if (!hasMore) return;
    setVisibleCount((prev) => Math.min(prev + 5, rows.length));
  };

  return (
    <Wrap>
      <Sheet>
        <PageTopBar />

        <Body>
          <BrandHeader subtitle="교육센터" />

          {/* 상단 안내 카드 - 관리자 설정값 반영 */}
          <IntroCard>
            <IntroText>
              <h2>{channelTitle}</h2>
              <p>{channelDescription}</p>
            </IntroText>
            <Mascot>
              {channelIconImg ? (
                <img src={channelIconImg} alt="교육채널 아이콘" />
              ) : (
                "🐶"
              )}
            </Mascot>
          </IntroCard>

          <Section>
            {/* 제목 */}
            <SectionTitle>{sectionTitleText}</SectionTitle>

            {/* 리스트 영역: 스피너 + 리스트/빈 상태 */}
            <div style={{ minHeight: 140 }}>
              {displayLoading && (
                <div
                  style={{
                    padding: 16,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    marginTop: 24,
                  }}
                >
                  <InlineSpinner />
                </div>
              )}

              {!displayLoading && !has && (
                <div style={{ padding: 12, color: "#64748b" }}>
                  등록된 교육자료가 없습니다.
                </div>
              )}

              {!displayLoading && has && (
                <List>
                  {visibleRows.map((r) => (
                    <Item key={r.id} onClick={() => openDetail(r.id)}>
                      <ItemText>
                        <div className="title">
                          {r.title}
                          {isNew(r.publishedAt) && (
                            <span
                              style={{
                                marginLeft: 6,
                                color: "#16a34a",
                                fontSize: 12,
                                fontWeight: 900,
                              }}
                            >
                              NEW
                            </span>
                          )}
                        </div>
                        <div className="meta">
                          {fmt(r.publishedAt)}
                          {r.videoUrl && <MetaVideo>· 영상</MetaVideo>}
                        </div>
                      </ItemText>
                      <div>›</div>
                    </Item>
                  ))}
                </List>
              )}
            </div>

            {/* 자료 더 보기: 남은 자료가 있을 때만 노출 */}
            {!displayLoading && has && hasMore && (
              <CTA
                onClick={handleLoadMore}
                $bg={seeMoreBgColor}
                $color={seeMoreTextColor}
              >
                {seeMoreLabel}
              </CTA>
            )}
          </Section>

          <BottomPad />
        </Body>
      </Sheet>
    </Wrap>
  );
}
